import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";
import { Logo } from "../Logo";
import { resellerWaLink, RESELLER_GENERIC_MSG } from "../../data/reseller";

export const ResellerHeader = () => (
  <header className="sticky top-0 z-40 backdrop-blur-md bg-ink/80 border-b border-white/5">
    <div className="max-w-[1300px] mx-auto px-5 md:px-6 py-3 flex items-center justify-between gap-3">
      <Link to="/" data-testid="reseller-home-link" className="flex items-center gap-2 group">
        <ArrowLeft className="w-4 h-4 text-white/60 group-hover:text-white transition-colors" />
        <Logo variant="horizontal" className="h-8 sm:h-11 max-w-none" testId="reseller-logo" />
      </Link>
      <nav className="flex items-center gap-2">
        <a href="#pacotes" data-testid="reseller-nav-packages" className="hidden sm:inline-flex px-4 py-2 rounded-full text-sm text-silver hover:text-white hover:bg-white/5 transition-colors">Pacotes</a>
        <a href="#faq" data-testid="reseller-nav-faq" className="hidden sm:inline-flex px-4 py-2 rounded-full text-sm text-silver hover:text-white hover:bg-white/5 transition-colors">Dúvidas</a>
        <a
          href={resellerWaLink(RESELLER_GENERIC_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reseller-header-whatsapp"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:brightness-110 text-white text-sm font-semibold transition"
        >
          <MessageCircle className="w-4 h-4" /> <span className="hidden sm:inline">WhatsApp</span>
        </a>
      </nav>
    </div>
  </header>
);
